import React, { useState, useEffect } from 'react';
import cx from 'classnames';
import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import { Pill, Button } from '@storable/canaveral-components';
import { LOCALE_PILL_VALUES, DEFAULT_LOCALE } from '../../../src/shared/i18n';
import styles from './styles.scss';
import { isDefaultLocale } from '../../../modules/i18n/locales';

const propTypes = {
  languages: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectedPage: PropTypes.shape({
    id: PropTypes.string.isRequired,
    locale: PropTypes.string.isRequired,
  }).isRequired,
  pages: PropTypes.shape({
    id: PropTypes.string.isRequired,
    locale: PropTypes.string.isRequired,
  }).isRequired,
  selectLanguage: PropTypes.func.isRequired,
};

const defaultProps = {};

const PageSettingsLanguagePills = ({
  selectedPage,
  languages,
  pages,
  selectLanguage,
}) => {
  const [currentLocale, setCurrentLocale] = useState(DEFAULT_LOCALE);
  const [availableLocales, setLocales] = useState([]);

  useEffect(() => {
    if (selectedPage) {
      setCurrentLocale(selectedPage.locale);
    }
  }, [selectedPage]);

  useEffect(() => {
    if (pages) {
      const locales = pages.map(page => page.locale);
      setLocales(locales);
    }
  }, [selectedPage, pages]);

  const onSelect = ({ locale }) => {
    const { id } = pages.find(page => page.locale === locale);
    selectLanguage(id);
  };

  return (
    <div className={styles.languagePills}>
      {languages.map((locale) => {
        const enabled = isDefaultLocale(locale) || availableLocales.includes(locale);

        const selected = currentLocale === locale;

        return (
          <Button
            onClick={enabled && !selected ? () => onSelect({ locale }) : null}
            key={locale}
            context="bare"
            className={styles.pillButton}
            disabled={!enabled}
          >
            <Pill
              className={cx(
                styles.pill,
                enabled ? [styles.enabledPill, styles.hoverable] : styles.disabledPill,
                selected && styles.selectedPill,
              )}
              diameter={LOCALE_PILL_VALUES[locale].length <= 2 ? 30 : null}
            >
              {LOCALE_PILL_VALUES[locale]}
            </Pill>
          </Button>
        );
      })}
    </div>
  );
};

PageSettingsLanguagePills.fragments = {
  page: gql`
    fragment PageSettingsLanguagesPage on Page {
      id
      live
      locale
      siblings {
        id
        locale
      }
      path
    }
  `,
};

PageSettingsLanguagePills.propTypes = propTypes;
PageSettingsLanguagePills.defaultProps = defaultProps;

export default PageSettingsLanguagePills;
